module.exports = {"mainnet":[],"testnet":[]}


//////////////////
// WEBPACK FOOTER
// ./src/libs/token.json
// module id = B1zG
// module chunks = 1